<template>
  <transition name="fade">
    <v-layout
      v-if="visible"
      align-center
      justify-center
      column
    >
      {{ $t('Common.boxGenericError') }}<br>
      <a
        :title="$t('Common.tryAgain')"
        @click.prevent="handleClick"
      >
        {{ $t('Common.tryAgain') }}.
      </a>
    </v-layout>
  </transition>
</template>

<script>
export default {
  name: 'Error',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('tryAgain')
    }
  }
}
</script>
